


; (function () {

    angular.module("EMR.InHouseVanSchedulerGiveApptCustomizationModule", []);


    var InHouseVanSchedulerGiveApptCustomizationRoutes = [
        {
            "name": "All_Clients_Appointment_Window_Objects_Customization",
            "templateUrl": "<div emr-all-clients-appointment-window-objects-customization></div>",
            "RoutingNumber": 2878,
            "settingId": 466,
            files: [
                "AngularScripts/InHouseVanSchedulerGiveApptCustomization/Services/AllClientsAppointmentWindowObjectsCustomizationService.js",
                "AngularScripts/InHouseVanSchedulerGiveApptCustomization/Directives/AllClientsAppointmentWindowObjectsCustomizationDirective.js",
            ]
        },
    ];



    angular.module('EMR.InHouseVanSchedulerGiveApptCustomizationModule')
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(InHouseVanSchedulerGiveApptCustomizationRoutes, $stateProvider);
            }]);
})();